import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_2 = { class: "modal-content shadow-lg" }
const _hoisted_3 = { class: "modal-header bg-primary text-white" }
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "card-body text-center p-4 text-primary" }
const _hoisted_9 = { class: "card-title fw-bold mb-2" }
const _hoisted_10 = { class: "mt-2" }
const _hoisted_11 = {
  key: 0,
  class: "card-footer bg-transparent border-0 text-center"
}
const _hoisted_12 = { class: "badge bg-success fs-6" }
const _hoisted_13 = { class: "modal-footer" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: "tv-selector",
    tabindex: "-1",
    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"])),
    ref: "tv-selector"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h5", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-tv me-2" }, null, -1)),
            _createTextVNode(_toDisplayString(_ctx.$t("tv-selector.lable")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            "data-bs-dismiss": "modal",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.televisions, (tv) => {
              return (_openBlock(), _createElementBlock("div", {
                key: tv._id,
                class: "col-md-4 mb-4"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card tv-card h-100 border-0 shadow-sm bg-info", {
                  selected: _ctx.selectedTvId === tv._id,
                  'border-primary': _ctx.selectedTvId === tv._id,
                }]),
                  onClick: ($event: any) => (_ctx.selectTv(tv))
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "tv-icon mb-3" }, [
                      _createElementVNode("i", {
                        class: "bi bi-tv",
                        style: {"font-size":"3rem"}
                      })
                    ], -1)),
                    _createElementVNode("h5", _hoisted_9, _toDisplayString(tv.tv_name), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("small", null, _toDisplayString(_ctx.$t(`change.room.${_ctx.$hotel}`, 1)) + ": " + _toDisplayString(tv.room_number), 1)
                    ])
                  ]),
                  (_ctx.selectedTvId === tv._id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, [
                          _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-check-circle me-1" }, null, -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("common.select.selection.selected")), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_7)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-x-circle me-1" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("common.cancel.cancel")), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-success",
            disabled: !_ctx.selectedTvId,
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirmSelection && _ctx.confirmSelection(...args)))
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("i", { class: "bi bi-check-circle me-1" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("common.select.selection.confirmSelection")), 1)
          ], 8, _hoisted_14)
        ])
      ])
    ])
  ], 512))
}